import React from 'react';
import { ScatterChart, CartesianGrid, Scatter, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import moment from 'moment/moment';


const OrderFrequencyScatterChart = props => {
  
  const period = props.period;
  let data;
  // period === ("hour" || "twoHourPeriod") ? period === "week" ? hourMapTemplate(period) : weekMapTemplate(props.content) : dayMapTemplate() 

  switch(period) {
    case "hour":
    case "twoHourPeriod":
      data = hourMapTemplate(period);
      break;
    case "week":
      data = weekMapTemplate(props.content);
      break;
    case "day":
      data = dayMapTemplate();
      break;
      default: break;
  }
  formatServiceData(period, data, props.content, props.element, props.currency);
  const xAxisName = period === "day" ? "Day" : "Time";
  const fontSizeLable = period === "week" ? 8 : 10;

  return (
    <ResponsiveContainer width="98%" height="100%" /*the width is not 100% because the tooltip increases the size for a second when is shown*/ >
      <ScatterChart /*width={props.width} height={props.height}*/ style={{ margin: 'auto' }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="index" name={xAxisName} tick={{ fontSize: fontSizeLable, fontWeight: 'bold' }} interval={0} />
        <YAxis width={35} tick={{ fontSize: 10, fontWeight: 'bold' }} />
        <Tooltip animationDuration={0} />
        <Scatter dataKey="count" name="Orders" data={data} fill="white" >
          {
            data.map((item, index) => {
              const color = period === "week" ? COLORS[parseIndex(index)] : COLORS[parseIndex(item.index)];
              return <Cell stroke={color} strokeWidth={3} />;
            })
          }
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
}

export default OrderFrequencyScatterChart;

const formatServiceData = (period, templateData, serviceData, element, currency) => {
  if (period === "hour") {
    serviceData.map(item => {
      switch (item.index) {
        case 0:
        case 1:
        case 2:
        case 3:
          templateData[0].count += item.count;
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          templateData[1].count += item.count;
          break;
        case 8:
        case 9:
        case 10:
        case 11:
          templateData[2].count += item.count;
          break;
        case 12:
        case 13:
        case 14:
        case 15:
          templateData[3].count += item.count;
          break;
        case 16:
        case 17:
        case 18:
        case 19:
          templateData[4].count += item.count;
          break;
        case 20:
        case 21:
        case 22:
        case 23:
          templateData[5].count += item.count;
          break;
        default: break;
      }
    })
  } else if (period === "twoHourPeriod") {
    serviceData.map( item => {
      switch (item.index) {
          case 0:
          case 1:
          templateData[0].count += item.count;
          break;
          case 2:
          case 3:
          templateData[1].count += item.count;
          break;
          case 4:
          case 5:
          templateData[2].count += item.count;
          break;
          case 6:
          case 7:
          templateData[3].count += item.count;
          break;
          case 8:
          case 9:
          templateData[4].count += item.count;
          break;
          case 10:
          case 11:
          templateData[5].count += item.count;
          break;
          case 12:
          case 13:
          templateData[6].count += item.count;
          break;
          case 14:
          case 15:
          templateData[7].count += item.count;
          break;
          case 16:
          case 17:
          templateData[8].count += item.count;
          break;
          case 18:
          case 19:
          templateData[9].count += item.count;
          break;
          case 20:
          case 21:
          templateData[10].count += item.count;
          break;
          case 22:
          case 23:
          templateData[11].count += item.count;
          break;
        default: break;
      }
    })
  } else if(period === "week") {
    serviceData.map( (item, index) => {
      const restaurantItemElement =  (element === 'ordersCount' && (item.orderCount || item.orderCount === 0)) ? item.orderCount : item.ordersCount;
      const itemElement = element === 'ordersCount' ? restaurantItemElement : Number(item.orderTotal.toFixed(2));
      switch(index) {
        case 0:
        templateData[0].count += itemElement;
        break;
        case 1:
        templateData[1].count += itemElement;
        break;
        case 2:
        templateData[2].count += itemElement;
        break;
        case 3:
        templateData[3].count += itemElement;
        break;
        case 4:
        templateData[4].count += itemElement;
        break;
        default: break;
      }
    })
  } else {
    serviceData.map(item => {
      switch (item.index) {
        case 1:
          templateData[0].count += item.count;
          break;
        case 2:
          templateData[1].count += item.count;
          break;
        case 3:
          templateData[2].count += item.count;
          break;
        case 4:
          templateData[3].count += item.count;
          break;
        case 5:
          templateData[4].count += item.count;
          break;
        case 6:
          templateData[5].count += item.count;
          break;
        default: break;
      }
    })
  }
}

const dayMapTemplate = () => {
  return [
    {
      "index": "MON",
      "count": 0
    },
    {
      "index": "TUE",
      "count": 0
    },
    {
      "index": "WED",
      "count": 0
    },
    {
      "index": "THU",
      "count": 0
    },
    {
      "index": "FRI",
      "count": 0
    },
    {
      "index": "SAT",
      "count": 0
    },
    {
      "index": "SUN",
      "count": 0
    }
  ]
};


const hourMapTemplate = (period) => {
  if (period === "hour") {
    return [
      {
        "index": "00-04",
        "count": 0
      },
      {
        "index": "04-08",
        "count": 0
      },
      {
        "index": "08-12",
        "count": 0
      },
      {
        "index": "12-16",
        "count": 0
      },
      {
        "index": "16-20",
        "count": 0
      },
      {
        "index": "20-00",
        "count": 0
      }
    ]
  }
  if (period === "twoHourPeriod") {
    return [
      {
        "index": "00-02",
        "count": 0
      },
      {
        "index": "02-04",
        "count": 0
      },
      {
        "index": "04-06",
        "count": 0
      },
      {
        "index": "06-08",
        "count": 0
      },
      {
        "index": "08-10",
        "count": 0
      },
      {
        "index": "10-12",
        "count": 0
      },
      {
        "index": "12-14",
        "count": 0
      },
      {
        "index": "14-16",
        "count": 0
      },
      {
        "index": "16-18",
        "count": 0
      },
      {
        "index": "18-20",
        "count": 0
      },
      {
        "index": "20-22",
        "count": 0
      },
      {
        "index": "22-00",
        "count": 0
      }
    ]
  }
  
};

const weekMapTemplate = (content) => {
  moment.defaultFormat = "DD.MM.YYYY HH:mm";

  return [
    {
       "index": content[0] && content[0].fromDate ? `${moment(content[0].fromDate, moment.defaultFormat).format('DD/MM/YY')}-${moment(content[0].toDate, moment.defaultFormat).format('DD/MM/YY')}`: '',
       "count": 0
    },
    {
      "index": content[1] && content[1].fromDate ? `${moment(content[1].fromDate, moment.defaultFormat).format('DD/MM/YY')}-${moment(content[1].toDate, moment.defaultFormat).format('DD/MM/YY')}`: '',
      "count": 0
    },
    {
      "index": content[2] && content[2].fromDate ? `${moment(content[2].fromDate, moment.defaultFormat).format('DD/MM/YY')}-${moment(content[2].toDate, moment.defaultFormat).format('DD/MM/YY')}`: '',
      "count": 0
    },
    {
      "index": content[3] && content[3].fromDate ? `${moment(content[3].fromDate, moment.defaultFormat).format('DD/MM/YY')}-${moment(content[3].toDate, moment.defaultFormat).format('DD/MM/YY')}`: '',
      "count": 0
    }
    // {
    //   "index": content[4] && content[4].fromDate ? `${moment(content[4].fromDate, moment.defaultFormat).format('DD/MM/YY')}-${moment(content[4].toDate, moment.defaultFormat).format('DD/MM/YY')}`: '',
    //   "count": 0
    // }
  ]
}

const parseIndex = index => {
  switch (index) {
    case "00-04":
    case "00-02":
    case 0:
    case "MON": return 0;
    case "04-08":
    case "02-04":
    case 1:
    case "TUE": return 1;
    case "08-12":
    case "04-06":
    case 2:
    case "WED": return 2;
    case "12-16":
    case "06-08":
    case 3:
    case "THU": return 3;
    case "16-20":
    case "08-10":
    case 4:
    case "FRI": return 4;
    case "20-00":
    case "10-12":
    case "SAT": return 5;
    case "12-14":
    case "SUN": return 6;
    case "14-16": return 7;
    case "16-18": return 8;
    case "18-20": return 9;
    case "20-22": return 10;
    case "22-00": return 11;
    default: return 12;
  }
}

const COLORS = [
  "#8B0000",
  "#DC143C",
  "#FF7F50",
  "#FF8C00",
  "#FFD700",
  "#EEE8AA",
  "#9ACD32",
  "#7FFF00",
  "#228B22",
  "#00FA9A",
  "#66CDAA",
  "#008080",
  "#40E0D0",
  "#5F9EA0",
  "#6495ED",
  "#9400D3",
  "#800080",
  "#DA70D6",
  "#FFB6C1",
  "#D8BFD8",
  "#FFEFD5",
  "#B0C4DE",
  "#708090",
  "#D8BFD8"
]


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/OrderFrequencyScatterChart.js